import type { CostCategory } from "@/features/cost-allocations/utils/categories";
import type { ReceivedInvoiceLineRow } from "../api/receivedInvoicesApi";

// Sugerencia a nivel factura para el default del split: la categoría sugerida
// que más plata concentra entre las líneas (por line_total_cents). Las líneas
// sin sugerencia no votan. Es solo un default editable — nunca auto-asigna.
export function dominantSuggestedCategory(lines: ReceivedInvoiceLineRow[]): CostCategory | null {
  const totals = new Map<CostCategory, number>();
  for (const line of lines) {
    if (line.suggestedCategory === null) continue;
    totals.set(
      line.suggestedCategory,
      (totals.get(line.suggestedCategory) ?? 0) + line.lineTotalCents,
    );
  }

  let winner: CostCategory | null = null;
  let winnerCents = 0;
  for (const [category, cents] of totals) {
    if (cents > winnerCents) {
      winner = category;
      winnerCents = cents;
    }
  }
  return winner;
}
